import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { SwiperComponent } from 'library-explorer';

@Component({
    selector: 'app-carousel-block',
    templateUrl: './carousel-block.component.html',
    styleUrls: ['./carousel-block.component.scss'],
    standalone: false
})
export class CarouselBlockComponent implements OnInit {

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  @Input() public block: any;

  public swiperOptions = {
    loop: true,
    breakpoints: {
      0: {
        slidesPerView: 1,
        showOverflow: true,
        reducedWidth: true,
        navigation: {
          enabled: false,
        },
      },
      480: {
        slidesPerView: 1,
        showOverflow: false,
        reducedWidth: false
      },
      992: {
        slidesPerView: 1,
        navigation: {
          enabled: true
        },
        showOverflow: false,
        reducedWidth: false
      }
    }
  }

  constructor() { }

  ngOnInit(): void {
  }

}
